export default __webpack_public_path__ + "static/pragicts-secops-services-sdwan-1577f3e7b07102c3eb0454d55f64256c.jpg";